const $inject = [];
const lbaTestFtpConnection = function () {
  return {
    restrict: 'A',
    scope: {
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaTestFtpConnectionCtrl',
    controllerAs: 'vm',
    template: require('./lbaTestFtpConnection.html')
  }
};

lbaTestFtpConnection.$inject = $inject;

export default lbaTestFtpConnection;



// WEBPACK FOOTER //
// ./src/components/lbaTestFtpConnection/lbaTestFtpConnectionDir.js